import { Directive, TemplateRef, Input } from "@angular/core";

@Directive({
  selector: "[medTemplate]",
})
export class MedTemplateDirective {
  constructor(public template: TemplateRef<any>) {}

  @Input("medTemplate") name = "";

  getType(): string {
    return this.name;
  }
}
